export default __webpack_public_path__ + "static/media/lap_image3.dddedad3.jfif";